import AOS from 'aos';

import './utils/vh.utils.js';
import './utils/animate-on-view.utils';

import './components/meta/select.component.js';
import './components/meta/marquee.component.js';
import './components/validation.component.js';

import './components/uploadFile.component.js';
import './components/header.component.js';
import './components/inputs.component.js';
import './components/animations.component.js';
import './components/player.component.js';
import './components/search-sec.component.js';

import './components/connect.component.js';

import './components/our-mission.component.js';
import './components/join-us.component.js';

import './components/sw-spotlight.component.js';
import './components/sw-our-vacancies.component.js';
import './components/sw-process.component.js';
import './components/sw-reviews.component.js';
import './components/sw-numbers.component.js';
import './components/sw-our-team.component.js';
import './components/sw-our-process.component.js';
import './components/sw-case-studies.component.js';
import './components/sw-similar-vacancies.component.js';
import './components/sw-benefits.component.js';
import './components/sw-snapshot.component.js';
import './components/sw-specializations.component.js';
import './components/sw-similar-insights.component.js';

import './components/cookies-btn.component.js';

import './libs/smoothScrollbar.lib.js';

AOS.init({
  offset: 50,
  delay: 10,
  duration: 600,
  easing: 'ease-in-out',
  once: true,
  startEvent: 'DOMContentLoaded',
});

const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
if(isSafari) document.body.classList.add('is-safari');

import './libs/countUp.lib.js';
